import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Menu } from 'antd'
import { inject, observer } from 'mobx-react'
// import styles from './index.scss'
import MyData from './MyData'
import AreaData from './AreaData'
import TeamData from './TeamData'

const SectionRenderMap = {
  my: <MyData />,
  area: <AreaData />,
  team: <TeamData />,
}

const TabsMap = {
  0: null,
  1: <Menu.Item key="team">我的团队情况</Menu.Item>,
  2: <Menu.Item key="area">我的片区情况</Menu.Item>,
}

interface IUStudyDataProps {
  userStore?: IUserStore.UserStore
}

@inject('userStore')
@observer
class UStudyData extends ComponentExt<IUStudyDataProps> {
  state = {
    currentSection: 'my',
  }

  handleChangeSectionClick = ({ key }) => {
    this.setState({
      currentSection: key,
    })
  }

  render() {
    const { currentSection } = this.state
    const currentSectionRender = SectionRenderMap[currentSection]
    const manageType = this.props.userStore.userInfo.manage_type

    return (
      <div>
        {manageType > 0 && (
          <section>
            <Menu
              onClick={this.handleChangeSectionClick}
              selectedKeys={[currentSection]}
              mode="horizontal"
            >
              <Menu.Item key="my">我的学习力数据</Menu.Item>
              {TabsMap[manageType]}
            </Menu>
          </section>
        )}
        {currentSectionRender}
      </div>
    )
  }
}

export default UStudyData
